<template>
  <b-row>
    <b-col sm="12">
      <b-card header-tag="header" footer-tag="footer">
        <b-row>
          <b-col>
            <h4 id="traffic" class="card-title mb-0">Depósitos</h4>
            <div class="small text-muted">Administración de todos los depósitos</div>
          </b-col>
                  <b-col cols="auto" class="d-flex align-items-center">
            <WidgetVisibilityConfig
              :widgets="widgetsMeta"
              :hidden="hiddenWidgets"
              :disabled="!visibilityLoaded"
              :locked="editingLocked"
              @toggle="onToggleWidget"
              @reset="resetWidgetsVisibility"
              @toggle-lock="setEditingLocked($event)"
            />
            <ChangelogWidget moduleKey="deposits" :limit="5" />
          </b-col>
</b-row>
      </b-card>

      <b-row>
        <b-col md="9">
                  <WidgetMasonry
                    v-if="visibilityLoaded"
                    v-model="widgetsOrdered"
                    :disabled="!visibilityLoaded || editingLocked"
                    @order-end="saveWidgetOrder"
                    @resize-end="commitWidgetSize"
                  >
                    <template v-slot:default="{ item }">
                        <Widget
                          :configWidget="configWidget"
                          :reference="item.reference"
                          :hasAccess="item.hasAccess"
                          :allowHide="!editingLocked"
                          :allowDrag="!editingLocked"
                          :allowResize="!editingLocked"
                          @hide-widget="hideWidget"
                        />
                    </template>
                  </WidgetMasonry>
        </b-col>  
        <b-col md="3">
          <b-list-group class="mb-1" v-if="configSubView.elements.deposits">
            <b-list-group-item href="#" class="flex-column align-items-start" @click="openDeposits()">
              <div class="d-flex w-100 justify-content-between">
                <h5 class="mb-1">Depósitos</h5>
                <small>
                  <b-icon icon="chevron-double-right" class="h5"></b-icon>
                </small>
              </div>

              <p class="mb-1">
                Configuración de los depósitos y sus zonas
              </p>
            </b-list-group-item>
          </b-list-group>

          <b-list-group class="mb-1" v-if="configSubView.elements.operations">
            <b-list-group-item href="#" class="flex-column align-items-start" @click="openDepositsOperations()">
              <div class="d-flex w-100 justify-content-between">
                <h5 class="mb-1">Operaciones</h5>
                <small>
                  <b-icon icon="chevron-double-right" class="h5"></b-icon>
                </small>
              </div>

              <p class="mb-1">
                Operaciones en depósito de productos
              </p>
            </b-list-group-item>
          </b-list-group>          

          <b-list-group class="mb-1" v-if="configSubView.elements.stock_count">
            <b-list-group-item href="#" class="flex-column align-items-start" @click="openStockCount()">
              <div class="d-flex w-100 justify-content-between">
                <h5 class="mb-1">Recuento de Stock</h5>
                <small>
                  <b-icon icon="chevron-double-right" class="h5"></b-icon>
                </small>
              </div>
              <p class="mb-1">
                Visualización y ajustes de stock por depósito
              </p>
            </b-list-group-item>
          </b-list-group>

          <b-list-group class="mb-1" v-if="configSubView.elements.stock_locations">
            <b-list-group-item href="#" class="flex-column align-items-start" @click="openDepositsQueryLocations()">
              <div class="d-flex w-100 justify-content-between">
                <h5 class="mb-1">Stock por Ubicación</h5>
                <small>
                  <b-icon icon="chevron-double-right" class="h5"></b-icon>
                </small>
              </div>

              <p class="mb-1">
                Consulta del movimiento de stock por ubicación
              </p>
            </b-list-group-item>
          </b-list-group>  

          <b-list-group class="mb-1" v-if="configSubView.elements.stock_products">
            <b-list-group-item href="#" class="flex-column align-items-start" @click="openDepositsQuery()">
              <div class="d-flex w-100 justify-content-between">
                <h5 class="mb-1">Stock por Productos</h5>
                <small>
                  <b-icon icon="chevron-double-right" class="h5"></b-icon>
                </small>
              </div>

              <p class="mb-1">
                Consulta del movimiento de stock por producto
              </p>
            </b-list-group-item>
          </b-list-group>      
          
          <hr v-if="arr.PHPCustom.length && configSubView.elements.php_custom">
          <b-list-group class="mt-2" v-if="arr.PHPCustom.length && configSubView.elements.php_custom">
            <b-list-group-item v-for="item in arr.PHPCustom" :key="item.id" href="#" class="flex-column align-items-start" @click="openPHPCustom(item)">
              <div class="d-flex w-100 justify-content-between">
                <h5 class="mb-1">{{item.name}}</h5>
                <small>
                  <b-icon icon="chevron-double-right" class="h5"></b-icon>
                </small>
              </div>

              <p class="mb-1">
                {{item.observations}}
              </p>
            </b-list-group-item>
          </b-list-group>          
        </b-col>        
      </b-row>

    </b-col>
  </b-row>
</template>
<script>
  import serviceAPI from './services'
  import Error from '@/handler/error'
  import Session from '@/handler/session'
  import Profiles from '@/config/profiles'
  import Modules from '@/config/modules'
  import Helper from '@/handler/helper'
  import Widget from '@/components/inc/widget/widget'
  import WidgetVisibilityConfig from '@/components/inc/widget/WidgetVisibilityConfig'
  import WidgetMasonry from '@/components/inc/widget/WidgetMasonry'
  import DashboardWidgetsHelper from '@/components/inc/widget/DashboardWidgetsHelper'
import ChangelogWidget from '@/components/inc/changelog/ChangelogWidget'
  import ServicesPHP from '@/components/modules/users/php/staff/services'

  export default {
    mixins: [DashboardWidgetsHelper],
    components: {
      Widget,
      WidgetVisibilityConfig,
      WidgetMasonry,
      ChangelogWidget
    },
    data: () => {
      return {
        access: {
          module_id: Modules.DEPOSITOS,
          profile_id: Profiles.PERSONAL,
          view_reference: 'dashboard',
          elements: {}
        },
        configWidget: {
          module_id: Modules.DEPOSITOS,
          profile_id: Profiles.PERSONAL,
          elements: {}
        },
        configSubView: {
          module_id: Modules.DEPOSITOS,
          profile_id: Profiles.PERSONAL,
          elements: {
            deposits: true,
            operations: true,
            stock_count: true,
            stock_locations: true,
            stock_products: true,
            php_custom: true,
          }
        },
        primaryColor: '',
        arr: {
          PHPCustom: []
        }        
      }
    },
    created () {
      /* Configurar permisos de vistas y elementos */
      Helper.hasAccessView(this.access)
      /* Fin configuracion */

      this.initDashboardWidgets()

      
      /* Configurar permisos de las sub vistas */
      this.configSubView.elements.deposits = Helper.showAccessView(this.configSubView, 'crudDeposits')
      this.configSubView.elements.operations = Helper.showAccessView(this.configSubView, 'crudDepositsOperations')
      this.configSubView.elements.stock_count = Helper.showAccessView(this.configSubView, 'crudDepositsStockCount')
      this.configSubView.elements.stock_locations = Helper.showAccessView(this.configSubView, 'crudDepositsQueryByLocations')
      this.configSubView.elements.stock_products = Helper.showAccessView(this.configSubView, 'crudDepositsQuery')
      this.configSubView.elements.stock_products = Helper.showAccessView(this.configSubView, 'crudDepositsQuery')
      this.configSubView.elements.php_custom = Helper.showAccessPHPCustom()
      /* Fin configuracion */
    },
    mounted() {
      this.setup()
      this.getPHPCustom()
    }, 
    methods: {
      setup () {        
        if(Session.getSession().settings) {    
          this.primaryColor = Session.getSession().settings.color_primary
                    
          this.createCSS()
        }
      },         
      createCSS() {
        var hoja = document.createElement('style')
        hoja.innerHTML = ""      
        hoja.innerHTML = hoja.innerHTML  + ".list-group-item-action:hover, .list-group-item-action:focus { background-color: " + this.primaryColor + "; }"

        document.body.appendChild(hoja);
      }, 
      openDeposits() {
        this.$router.push({ name: 'DepositsStaffCrudDeposits' })
      },
      openDepositsOperations() {
        this.$router.push({ name: 'DepositsStaffCrudDepositsOperations' })
      },
      openDepositsQuery() {
        this.$router.push({ name: 'DepositsStaffCrudDepositsQuery' })
      },      
      openDepositsQueryLocations() {
        this.$router.push({ name: 'DepositsStaffCrudDepositsQueryLocations' })
      }, 
      openStockCount() {
        this.$router.push({ name: 'DepositsStaffCrudDepositsStockCount' })
      },     

      getPHPCustom() {
        ServicesPHP.obtenerPHPByModule(Modules.DEPOSITOS)
        .then((response) => {
          this.arr.PHPCustom = response.data       
        })
      },
      openPHPCustom(item) {
        this.$router.push({ name: 'ViewStaffViewPHPCustom', params: {id: item.id} })
      }             
    }    
   
  }
</script>

<style>

</style>
